import React from 'react'
import PropTypes from 'prop-types'
import { FaCloudUploadAlt } from 'react-icons/fa'

import { BoxLink, Text } from './theme'

const UploadImage = ({ onDrop }) => (
  <BoxLink onDrop={onDrop}>
    <FaCloudUploadAlt />
    <Text>Dodaj zdjęcie</Text>
  </BoxLink>
)

UploadImage.propTypes = {
  onDrop: PropTypes.func.isRequired,
}

export default UploadImage



// WEBPACK FOOTER //
// ./src/components/UploadImage/index.js